import { AppBar, IconButton, Toolbar } from '@mui/material';
import { ArchiveIcon, ChartLineUpIcon, colors, palette, PatientLostIcon } from '@silbo/ui';
import { Link, useLocation } from '@tanstack/react-router';

const BottomBar = () => {
  const { pathname } = useLocation();
  return (
    <AppBar
      position="fixed"
      sx={{ top: 'auto', bottom: 0, bgcolor: palette.background.default, paddingBottom: 'env(safe-area-inset-bottom)' }}
      component="footer"
    >
      <Toolbar
        sx={{
          padding: 0,
          justifyContent: 'space-between',
          '& .MuiIconButton-root': {
            '& .MuiSvgIcon-root': {
              width: '24px !important',
              height: '24px !important',
            },
          },
        }}
      >
        <Link
          to="/bed-management/statistics"
          style={{
            display: 'flex',
            justifyContent: 'center',
            flex: 1,
          }}
        >
          <IconButton disableRipple sx={{ borderRadius: 0 }}>
            <ChartLineUpIcon sx={{ color: pathname.includes('statistics') ? colors.grey[100] : colors.grey[30] }} />
          </IconButton>
        </Link>
        <Link
          to="/bed-management/requests"
          style={{
            display: 'flex',
            justifyContent: 'center',
            flex: 1,
          }}
        >
          <IconButton disableRipple sx={{ borderRadius: 0 }}>
            <PatientLostIcon sx={{ color: pathname.includes('requests') ? colors.grey[100] : colors.grey[30] }} />
          </IconButton>
        </Link>
        <Link
          to="/bed-management/archives"
          style={{
            display: 'flex',
            justifyContent: 'center',
            flex: 1,
          }}
        >
          <IconButton disableRipple sx={{ borderRadius: 0 }}>
            <ArchiveIcon sx={{ color: pathname.includes('archive') ? colors.grey[100] : colors.grey[30] }} />
          </IconButton>
        </Link>
      </Toolbar>
    </AppBar>
  );
};

export default BottomBar;
